<template>
  <div class="payment-charge-wrap">
    <payment-form @paymentResponse="paymentResponse" @validated="validationResult" ref="paymentForm"></payment-form>
    <div class="form-area dynamic">
      <div class="billing-contact">
        <h4>Billing Contact</h4>
        <div class="form-row">
          <div v-if="email" class="toggle-wrap">
            <label class="switch">
              <input type="checkbox" v-model="useCurrentEmail">
              <span class="slider"></span>
              Use my email
            </label>
          </div>
          <p ref="name-error" class="field-error" :class="{ 'show-error' : billingError }">Grr... Please add a valid billing contact email.</p>
          <div class="input-wrap" :class="{ 'show-error' : billingError }">
            <input v-model="billingContact" id="billing" name="billing" class="center-input" type="text" placeholder="email@example.com" :disabled="useCurrentEmail" required>
          </div>
        </div>
      </div>
      <p class="charge">
        <strong>{{'$' + Number(pricing[config.productName].chargePrice).toFixed(0)}} charged today.</strong>
        {{'$' + Number(pricing[config.productName].regularPrice).toFixed(0)}}/user charged after trial.
      </p>
      <p class="field-error" :class="{ 'show-error' : formError }">{{ formError }}</p>
      <submit-button @submit="submit" :finished="finished">Start your free trial</submit-button>
    </div>
    <modal ref="modal" :closeable="true">
      <portal :type="portalType"></portal>
    </modal>
  </div>
</template>

<script>
import paymentForm from '../../components/payment-form/payment-form'
import modal from '@/components/modal/modal'
import portal from '@/components/portal/portal'
import marketing from '../../services/marketing.js'
import submitButton from '@/components/submit-button/submit-button'
import is from 'is_js'

export default {
  name: 'payment-teams',
  components: {
    'payment-form': paymentForm,
    'submit-button': submitButton,
    'modal': modal,
    'portal': portal
  },
  props: ['pricing', 'config', 'modal'],
  data () {
    return {
      couponPricing: null,
      submitted: false,
      finished: false,
      formError: '',
      billingContact: '',
      activeField: {
        billingContact: false
      },
      useCurrentEmail: false,
      billingError: false,
      watcher: null,
      marketingData: marketing.paymentTracking(this.$route)
    }
  },
  created: function () {
    if (this.modal) {
      this.watcher = this.$store.watch((state, getters) => getters.isLoggedIn, () => {
        this.finishSubmit()
      })
    }
    this.$store.dispatch('getUserData')
  },
  computed: {
    portalType: function () {
      return this.$route.path.indexOf('upgrade') > -1 ? 'login' : 'signup'
    },
    coupon: function () {
      return this.pricing.YEARLY_PAYMENT_RECURRING.coupon || {}
    },
    validBillingContact: function () {
      return is.email(this.billingContact)
    },
    email: function () {
      let email = ''
      if (this.$store.getters.userData && this.$store.getters.userData.user) {
        email = this.$store.getters.userData.user
      }
      return email
    }
  },
  methods: {
    toggleCurrentEmail: function () {
      if (this.useCurrentEmail && this.email) {
        this.billingContact = this.email
      } else {
        this.billingContact = ''
      }
    },
    submit: function () {
      this.formError = ''
      this.$refs.paymentForm.isValidated()
    },
    validationResult: function (valid) {
      if (valid) {
        if (!this.validBillingContact) {
          this.billingError = true
        } else if (!this.$store.getters.isLoggedIn && this.modal) {
          this.$refs.modal.openModal()
        } else {
          this.$refs.paymentForm.submit()
        }
      }
    },
    finishSubmit: function () {
      this.$refs.modal.closeModal()
      this.$refs.paymentForm.submit()
    },
    paymentResponse: function (response) {
      if (response.error) {
        this.$store.dispatch('submitting', false)
        this.formError = response.error.message || 'Whoops... something went wrong with your request. Please refresh and try again.'
      } else {
        let data = {
          token: response.token.id,
          productName: this.config.productName,
          name: this.config.name,
          industry: this.config.industry,
          billingContact: this.billingContact
        }
        if (this.coupon.code) {
          data.couponCode = this.coupon.code
        }

        let endpoint = this.config.endpoint || '/team/create'
        data = Object.assign(data, this.marketingData)
        data = Object.assign(data, marketing.marketingParams('tb4t'))
        this.$http.post(this.ENV.paymentBaseUrl + endpoint, data).then((response) => {
          if (response.data.result === 'FAIL') {
            this.formError = response.data.details || 'Whoops... something went wrong with your request. Please refresh and try again.'
            this.$store.dispatch('submitting', false)
            return
          }
          window.dataLayer = window.dataLayer || []
          window.dataLayer.push({
            'transactionId': response.data.transId,
            'transactionTotal': response.data.amountPaid,
            // 'transactionTax': 1.29,
            'transactionProducts': [{
              'sku': response.data.product,
              'name': response.data.product,
              'price': response.data.amountPaid,
              'quantity': 1
            }]
          })
          this.$store.dispatch('submitting', false)
          this.finished = true
          setTimeout(() => {
            this.$emit('chargeResponse', 'PASS')
          }, 2000)
          marketing.removeAllCookies()
          this.$store.dispatch('getTeamData', true)
        }).catch(() => {
          this.formError = 'Whoops... something went wrong with your request. Please refresh and try again.'
          this.$store.dispatch('submitting', false)
        })
      }
    }
  },
  watch: {
    billingContact: function (entry) {
      if (entry) this.billingError = false
    },
    useCurrentEmail: function () {
      this.toggleCurrentEmail()
    }
  },
  beforeDestroy: function () {
    // unwatch this function
    this.watcher()
  }
}
</script>

<style scoped lang="stylus" src="./payment-teams.styl" >



// WEBPACK FOOTER //
// src/components/payment-teams/payment-teams.vue